import React from 'react';
import LanguageSwitcher from '../LanguageSelection/LanguageSwitcher';
import SettingsButton from '../Common/Settings/Buttons/SettingsButton';

interface HeaderProps {
  onMenuClick?: () => void;
  onSettingsClick?: () => void;
  showSettings?: boolean;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, onSettingsClick, showSettings = false }) => {
  return (
    <header className="flex-shrink-0 p-4 sm:px-6 z-10 bg-black/10 backdrop-blur-sm border-b border-white/20">
      <div className="flex items-center justify-between">
        <div className="w-9 h-9">
          <LanguageSwitcher />
        </div>
        <a href='/'>
          <h1 className="text-xl font-black text-white drop-shadow-md m-0">
            GatherPlay
          </h1>
        </a>
        <div className="flex items-center gap-2">
          {showSettings && <SettingsButton onClick={onSettingsClick || (() => {})}/>}
        </div>
      </div>
    </header>
  );
};

export default Header;